import {InputType, TargetType} from '../../types/project/Application';
import {
  getSinglePageApplicationById,
  getOrCreateSinglePageApplication,
  getSinglePageApplicationsByApplicationId,
} from '../../api/application/GetSpa';
import {toast} from '../../base-components/StudioToast';

export async function getInferenceApplication(
  spaId: string | undefined,
  applicationId: string
) {
  const {data: spaResponse} = await getSinglePageApplicationById({spaId, applicationId});
  if (spaId && spaResponse && spaResponse?.errors && spaResponse?.errors?.length > 0) {
    toast.error(spaResponse?.errors);
    return undefined;
  }
  return spaResponse?.body;
}

export async function getInferenceApplicationsByApplicationId(applicationId: string) {
  const {data: spaResponse} = await getSinglePageApplicationsByApplicationId({
    applicationId,
  });
  if (spaResponse && spaResponse?.errors && spaResponse?.errors?.length > 0) {
    toast.error(spaResponse?.errors);
    return undefined;
  }
  return spaResponse?.body;
}

export async function getNewOrExistingInferenceApplication(
  projectId: string,
  applicationId: string,
  deploymentId: string | undefined,
  inputType: InputType,
  targetType: TargetType
) {
  const {data: spaResponse} = await getOrCreateSinglePageApplication({
    projectId,
    applicationId,
    deploymentId,
    inputType,
    targetType,
  });
  if (spaResponse && spaResponse.errors && spaResponse.errors?.length > 0) {
    toast.error(spaResponse.errors);
    return undefined;
  }
  return spaResponse?.body;
}
